import { Button } from "@shared/ui/button";
import { Card, CardContent } from "@shared/ui/card";
import { FileText, Zap, ShieldCheck } from "lucide-react"; // changed CheckCircle to ShieldCheck
import { useNavigate } from "react-router-dom";
import React from "react";

// Features data
const FEATURES = [
  {
    icon: <FileText className="w-10 h-10 text-blue-500" />,
    title: "Smart File Recognition",
    description: "AI automatically detects and maps your data structure",
    bullets: [
      "Supports CSV, format up to 20MB",
      "Validates file structure and identifies data types",
      "Detects missing columns and formatting issues",
      "95% accuracy in automatic structure detection",
    ],
  },
  {
    icon: <Zap className="w-10 h-10 text-purple-500" />,
    title: "Intelligent Data Mapping",
    description: "Automatic suggestions to map your data to system fields",
    bullets: [
      "AI suggests field mappings with confidence scores",
      "Handles complex data transformations automatically",
      "Reduces manual mapping time by 80%",
      "Learns from previous successful mappings",
    ],
  },
  {
    icon: <ShieldCheck className="w-10 h-10 text-green-500" />,
    title: "Smart Validation",
    description: "Identify and fix issues before finalizing the upload",
    bullets: [
      "Auto-fixes date formats, postal codes, phone numbers",
      "Generates missing required fields (IDs, references)",
      "Prevents 90% of common upload errors",
      "Provides detailed error reports with solutions",
    ],
  },
];

export const OverviewCards: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        {FEATURES.map((feature, index) => (
          <Card key={index} className="text-center">
            <CardContent className="py-6">
              <div className="flex justify-center mb-4">{feature.icon}</div>
              <h3 className="font-medium text-lg">{feature.title}</h3>
              <p className="text-sm text-muted-foreground mt-2">
                {feature.description}
              </p>
              <ul className="mt-3 text-sm text-muted-foreground list-disc list-inside text-left space-y-1">
                {feature.bullets.map((bullet, idx) => (
                  <li key={idx}>{bullet}</li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Highlighted info box */}
      <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6 text-center">
        <p className="font-medium text-green-800 flex items-center justify-center gap-2">
          ⚡ Complete migration in 5-15 minutes vs 2+ hours manual process
        </p>
        <p className="text-green-700 mt-1">
          Our AI-powered system handles the heavy lifting, so you can focus on
          what matters most
        </p>
      </div>

      {/* Button */}
      <div className="flex justify-center">
        <Button
          className="px-6 py-2 text-base"
          onClick={() => navigate("/onboarding/data-migration/data-setup")}
        >
          Start Data Upload
        </Button>
      </div>
    </div>
  );
};
